import {
  UPDATE_CLUB_SIGNUP_REQUEST,
  GET_CLUB_SIGNUP_REQUEST,
  GET_CLUB_SIGNUP_HOSTED_PAYMENT_REQUEST,
  UPDATE_CLUB_SIGNUP_WITH_PASSWORD_REQUEST,
  UPDATE_CLUB_SIGNUP_WITH_PASSWORD_AND_PROCESS_REQUEST,
  CREATE_CLUB_SIGNUP_REQUEST,
  UPDATE_AND_PROCESS_CLUB_SIGN_UP_REQUEST,
  CLUB_SIGNUP_STEP_REQUEST,
  SEND_CLUB_SIGNUP_TO_HOSTED_PAYMENT_REQUEST
} from './constants';

export const createClubSignup = (clubSlug) => ({
  type: CREATE_CLUB_SIGNUP_REQUEST,
  clubSlug
});

export const getClubSignup = () => ({ type: GET_CLUB_SIGNUP_REQUEST });

export const getClubSignupForHostedPayment = (
  successFunction,
  errorFunction
) => ({
  type: GET_CLUB_SIGNUP_HOSTED_PAYMENT_REQUEST,
  successFunction,
  errorFunction
});

export const updateClubSignup = (clubSignup, successFunction) => ({
  type: UPDATE_CLUB_SIGNUP_REQUEST,
  clubSignup,
  successFunction
});

export const updateAndProcessClubSignup = (clubSignup, successFunction) => ({
  type: UPDATE_AND_PROCESS_CLUB_SIGN_UP_REQUEST,
  clubSignup,
  successFunction
});

export const updatePassword = (data, clubSignup, successFunction) => ({
  type: UPDATE_CLUB_SIGNUP_WITH_PASSWORD_REQUEST,
  data,
  clubSignup,
  successFunction
});

export const updatePasswordAndProcess = (
  data,
  originalClubSignup,
  successFunction
) => ({
  type: UPDATE_CLUB_SIGNUP_WITH_PASSWORD_AND_PROCESS_REQUEST,
  data,
  originalClubSignup,
  successFunction
});

export const checkoutStep = (step, clubSignup) => ({
  type: CLUB_SIGNUP_STEP_REQUEST,
  payload: {
    step,
    clubSignup
  }
});

export const sendToHostedPayment = (redirectFunction) => ({
  type: SEND_CLUB_SIGNUP_TO_HOSTED_PAYMENT_REQUEST,
  redirectFunction
});
